import { CREATIVE_OCS_MESSAGE } from 'common/js/creative-frame-messages';
import { CreativeTagEvent } from '../enums';
import { EventEmitter } from '../types';

export class OcsIdentityHandler {
  constructor(
    private readonly eventSource: EventEmitter<CreativeTagEvent>,
    private readonly aWindow: Window
  ) {
    this.eventSource.addEventListener(CreativeTagEvent.CreativeRequested, () =>
      this.announce()
    );
  }

  private announce(): void {
    // A DSP wrapper that writes the tag at runtime hides it from the ad parser.
    this.aWindow.parent?.postMessage({ type: CREATIVE_OCS_MESSAGE }, '*'); // NOSONAR: an opaque origin cannot be named as a target
  }
}
